// Imports
import styled, { css } from 'styled-components/macro';
import helperFunctions from '../../../../../../../shareables/foundation/front-end/utils/helper-functions';
import modalHelpers from '../../../../../../../shareables/front-end/modal/modal-helpers';
import { GeneratedThemeProps } from '../../../../../../templates/template-style';


// Styled components
const SpanLink = styled.span<{ theme: GeneratedThemeProps }>`
	color: ${(props) => props.theme.contentLinkColor};
	text-decoration: ${(props) => (props.theme.isPaper ? 'underline' : 'none')};
	cursor: pointer;
	
	&:hover,
	&:focus {
		color: ${(props) => props.theme.contentLinkHoverColor};
		
		${(props) =>
			props.theme.isPaper &&
			css`
				text-decoration: none;
			`};
	}
`;


// Function component
const AskGenderModalNote: React.FC = () => {
	// Return JSX
	return (
		<em>
			Your gender is never displayed to others.{' '}
			<SpanLink {...helperFunctions.buttonize(() => modalHelpers.show('ask-gender-modal'))}>Learn more</SpanLink> about
			why we ask for this information.
		</em>
	);
};

export default AskGenderModalNote;
